module.exports = __webpack_public_path__ + "img/book.7ac74a31.png";